declare var process: any;
declare var require: any;

import * as React from 'react';
import { IconButton, Title, RouteWrapper, Hero } from '../components';

const logo = require('../assets/logo-white.svg');

const Route = () => (
  <RouteWrapper requireNoAuth title="Home">
    <Hero className="is-primary is-fullheight">
      <div>
        <img width="400" src={logo} alt={process.env.APP_NAME} />
      </div>
      <Title>Booking System</Title>
      <IconButton
        large
        link="/login"
        className="is-primary is-inverted is-outlined"
        icon="arrow-circle-right"
      >
        Login
      </IconButton>
      &nbsp;
      <IconButton
        large
        link="/signatures"
        className="is-primary is-inverted is-outlined"
        icon="pencil"
      >
        Sign
      </IconButton>
    </Hero>
  </RouteWrapper>
);

export default Route;
